/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceUserDto } from '../../models/client-workspace-user-dto';

export interface ClientWorkspaceUserControllerDelegate$Params {

/**
 * 고객사 ID
 */
  id: string;

/**
 * 위임할 구성원 ID
 */
  userId: string;
}

export function clientWorkspaceUserControllerDelegate(http: HttpClient, rootUrl: string, params: ClientWorkspaceUserControllerDelegate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceUserControllerDelegate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceUserDto>;
    })
  );
}

clientWorkspaceUserControllerDelegate.PATH = '/api/clientWorkspaceUser/{id}/users/{userId}/delegate';
